/*
 * @Author: Teemo Ding
 * @Date: 2021-07-08 17:29:44
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-15 10:01:46
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelOrder/config.tsx
 */
import React from 'react';
import WarningPopReminder from 'src/constrains/PopReminder/Warning';
import css from './css.module.less';

export const breadcrumbData = (
  salesChannelName,
  salesChannelUuid,
  { getI18n },
) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/salesChannels',
    name: getI18n('general.sider.salesChannel'),
  },
  {
    url: `/salesChannel/content/${salesChannelUuid}`,
    name: salesChannelName,
  },
  {
    url: `/salesChannel/settings/${salesChannelUuid}`,
    name: getI18n('general.sider.settings'),
  },
  {
    url: '',
    name: getI18n('general.storeCommunicationSetting.order'),
  },
];
export enum LimitationAppliesValues {
  EACH_ORDER = 'EACH_ORDER',
  EACH_CUSTOMER = 'EACH_CUSTOMER',
}

export enum LimitationPeriodValues {
  LIFE_TIME = 'LIFE_TIME',
  SPECIFIC_PERIOD = 'SPECIFIC_PERIOD',
}

export enum PeriodUnitValues {
  ROLLING_DAYS = 'ROLLING_DAYS',
  CALENDAR_YEARS = 'CALENDAR_YEARS',
  CALENDER_MONTHS = 'CALENDER_MONTHS',
}

export enum OrderOptionsValues {
  AFTER_PURCHASED = 'AFTER_PURCHASED',
  AFTER_DELIVERED = 'AFTER_DELIVERED',
}

export enum OrderType {
  Return = 'Return',
  Refund = 'Refund',
}

export const limitationApplies = ({ getI18n }) => [
  {
    value: LimitationAppliesValues.EACH_ORDER,
    label: getI18n('salesChannelOrder.index.eachorder'),
  },
  {
    value: LimitationAppliesValues.EACH_CUSTOMER,
    label: getI18n('salesChannelOrder.index.eachcustomer'),
  },
];

export const limitationPeriodList = ({ getI18n }) => [
  {
    value: LimitationPeriodValues.LIFE_TIME,
    label: getI18n('salesChannelOrder.index.lifetime'),
  },
  {
    value: LimitationPeriodValues.SPECIFIC_PERIOD,
    label: getI18n('salesChannelOrder.index.specificperiod'),
  },
];

export const periodUnitList = ({ getI18n }) => [
  {
    value: PeriodUnitValues.ROLLING_DAYS,
    label: getI18n('salesChannelOrder.index.rollingDays'),
  },
  {
    value: PeriodUnitValues.CALENDAR_YEARS,
    label: getI18n('salesChannelOrder.index.calendarYears'),
  },
  {
    value: PeriodUnitValues.CALENDER_MONTHS,
    label: getI18n('salesChannelOrder.index.calendarMonths'),
  },
];

export const orderOptions = ({ getI18n }) => [
  {
    value: OrderOptionsValues.AFTER_PURCHASED,
    label: getI18n('salesChannelOrder.index.afterpurchased'),
  },
  {
    value: OrderOptionsValues.AFTER_DELIVERED,
    label: getI18n('salesChannelOrder.index.afterdelivered'),
  },
];

export const termsConditionsColumns = (deleteFun, { getI18n }) => [
  {
    title: getI18n('salesChannelOrder.index.termsConditionsName'),
    dataIndex: 'name',
    key: 'name',
    default: true,
    optional: false,
    className: css.columnClass,
    width: 480,
  },

  {
    title: getI18n('salesChannelOrder.index.agreementRequiredOptional'),
    dataIndex: 'setAgreementAsRequired',
    default: true,
    optional: true,
    key: 'setAgreementAsRequired',
    className: css.columnClass,
    minWidth: 256,
    render: (text) =>
      text === true ? getI18n('general.required') : getI18n('general.optional'),
  },
  {
    title: getI18n(
      'general.advancedFilters.commonStoreProductsWithTable.actions',
    ),
    default: true,
    optional: true,
    key: 'actions',
    className: css.columnClass,
    minWidth: 320,
    render: (text, record) => (
      <WarningPopReminder
        title={getI18n('salesChannelOrder.index.removeTermsConditions')}
        content={getI18n(
          'salesChannelOrder.index.removeTermsConditionsContent',
        )}
        onOkText={getI18n('general.remove')}
        onOk={() => {
          deleteFun(record.uuid);
        }}>
        <a href='#' className={css.errorText}>
          {getI18n('general.delete')}
        </a>
      </WarningPopReminder>
    ),
  },
];
